export type {FavouriteRepositoryInterface} from './repository.interface'
export {ToggleFavouriteUseCase, type ToggleFavouriteResult} from './toggle-favourite.use-case'
